//@flow

const envConfig = require('../../../config/kaizen');
const iddCountries = require('../iddCountries/kaizen');
const products = require('../products/kaizen');

/**
 * RÉCUPÉRATION DE LA CONFIG DYNAMIQUE (WEB RUNTIME)
 */
const getDynamicConfig = () => {
  try {
    if (typeof window !== 'undefined' && window.WIZZEE_DYNAMIC_CONFIG) {
      return window.WIZZEE_DYNAMIC_CONFIG;
    }
  } catch (e) { }
  return {};
};

const dynamic = getDynamicConfig();

let themes = [];
if (!process.env.BUILD_WEB) {
  const Platform = require('react-native').Platform;
  themes.push(require('../themes/kaizen').default);
  if (Platform.OS !== 'web') {
    themes.push(require('../themes/tripica').default);
  }
}

// 1. Définition de la base complète
let config = {
  ...products,
  themes,
  locales: ['fr', 'en', 'translationKeys'], // locales[0] will be the default value if the customerLanguage isn't supported
  addZeroOptionForEachService: true,
  ageLimit: 18,
  areCheatCodesEnabled: true,
  showBatchDebugView: true,
  arePromotionCodeAndActivationBonusIncompatible: true,
  arePromotionCodeAndReferralPromotionIncompatible: true,
  askMiddleName: true,
  askPersonalInformationDuringOrderSim: true,
  brand: 'Wizzee',
  canAccessStyleGuide: false,
  canActivateWithAnAccountWithoutSubscriptions: true,
  canAddLines: true,
  canAddMoneyToWallet: true,
  canBuyRoamingPackage: false,
  canBuyRoamLikeHome: false,
  canBuyPremium: true,
  canBuyTravel: true,
  canChangeContactNumber: false,
  canChangeLanguage: false,
  canChangeMarketingApproval: true,
  canChangePhoneNumber: false,
  canChangePlanNow: false,
  canCheckContract: true,
  canChooseDeliveryMethod: false,
  canCreateAccountDuringActivate: true,
  canCustomersHaveActivationBonuses: false,
  canEditBillingAddressOnProfile: true,
  canEditOfferOnConfirmPlan: false,
  canEnterPromotionCode: true,
  canEnterReferralOrPromoCode: true,
  canEnterVoucher: true,
  canGetRioNumber: true,
  canKeepMyNumber: true,
  canManageLines: true,
  canManageVouchers: true,
  canOpenExternalWebview: true,
  canSelectPreferredNumbers: false,
  canSwapSim: true,
  canTerminateLine: false,
  canTurnBackOn: true,
  canUnsuspend: true,
  canUseDataRecommendationTool: false,
  canUseOnlineBanking: false,
  canWithdrawFromLine: true,
  country: 'FRA',
  currency: '€',
  displayActivateSimButtonOnInvitation: false,
  displayCheckboxOnRegisterPaymentmean: true,
  displayConfirmationModalOnConfirmPlan: true,
  displayConfirmationModalOnTopup: true,
  displayConditionOnConfirmPlan: true,
  displayConditionsModalOnConfirmPlan: false,
  displayConfirmInformationsTermsOnConfirmPlan: true,
  displayConfirmPersonalInformationText: false,
  displayCountryInEditionModeOnConfirmPersonalInfo: false,
  displayDeliveryContactOnConfirmPlan: false,
  displayDeliveryMethodInPendingDeliveryPanel: false,
  displayDeliveryMethodOnConfirmPlan: false,
  displayVouchersForTopup: true,
  displayVouchersForChoosePlan: true,
  displayVouchersForChangePlan: true,
  displayDeliveryStatusInPendingDeliveryPanel: 'label', // 'none' || 'timeline' || 'label'
  displayHouseNumber: false,
  displayIdentityRequirementLink: false,
  displayIncludedForFirstOptionValue: true,
  displayLegalBlurb: true,
  displayOptionPrice: false,
  displayPhoneNumberOnConfirmPlan: true,
  displayPricesShownAreExclusiveOfTaxMessage: false,
  displayRequiredToActivatePage: false,
  displayRoamLikeHome: false,
  displaySelfieCheck: false,
  displaySimIsAddedInOrder: false,
  displaySimPrice: true,
  displayTopUpTimelineSubtitles: false,
  displayRoamingPlanSliders: true,
  enableRoamingOptionsMockInCurrentSubscription: false,
  enableRoamingOptionsUsagesMock: false,
  displayTravelUsages: true,
  roamingServiceSpecs: ['ROA4_DATA', 'ROA5_DATA', 'ROA6_DATA', 'TO_ZONED_VOICE'],
  roamingDataServiceSpecs: ['ROA4_DATA', 'ROA5_DATA', 'ROA6_DATA'],
  zeroDataOptionOuid: 'KAIZEN_OPTDATA0GB_2026',
  zeroRoamingDataOptionOuid: 'KAIZEN_OPTDATA_ROA0_0GB_2026',
  zeroRoamingVoiceOptionOuid: 'KAIZEN_OPT_IDD_ZONED_0_2026',
  defaultDataOptionName: 'KAIZEN_OPTDATA180GB',
  defaultVoiceOptionName: 'KAIZEN_OPTVOICEUNL_2',
  roamingTerritoryMapping: {
    // Data roaming — progressive territory coverage
    KAIZEN_OPTDATA_ROA4_5GB: ['lca', 'dma', 'aia'],
    KAIZEN_OPTDATA_ROA5_10GB: ['lca', 'dma', 'aia', 'tto', 'brb'],
    KAIZEN_OPTDATA_ROA6_15GB: ['lca', 'dma', 'aia', 'tto', 'brb', 'usa', 'can'],
    // Voice roaming — same territories for all tiers
    KAIZEN_OPT_IDD_ZONED_30: ['lca', 'dma', 'aia', 'tto', 'brb', 'usa', 'can'],
    KAIZEN_OPT_IDD_ZONED_60: ['lca', 'dma', 'aia', 'tto', 'brb', 'usa', 'can'],
    KAIZEN_OPT_IDD_ZONED_120: ['lca', 'dma', 'aia', 'tto', 'brb', 'usa', 'can'],
  },
  simSerialNumberLength: 19,
  enableCheckOperator: false,
  enableOutOfZoneRoaming: true,
  genderFormatOnConfirmPersonalInfoPage: 'radio', // 'radio' || 'label'
  hideCreditWalletPayment: false,
  hidePendingOrderPanelOnDashboard: true,
  hideUnavailableRoaming: true,
  hideWallet: false,
  iddCountries,
  inferAddressStateOrProvinceFromPostCode: true,
  international: {
    IDD: 'IDD',
    BOOSTER: 'BOOSTER',
    ROAMING: 'ROAMING',
  },
  isBatchInboxEnabled: true,
  isFreeSimPathAvailable: false,
  isFullNameDisabled: false,
  isRioFieldDisplayed: true,
  kaizenPlan: [
    'DATA_AND_EUROPE_CREDIT',
    'DATA_CREDIT',
    'VOICE_CREDIT',
    'SMS_CREDIT',
  ],
  maxCreditWalletAmount: 50,
  minCreditWalletAmount: 1,
  maxPremiumAmount: 50,
  minPremiumAmount: 1,
  paymentTimelinePeriod: 3,
  paymentProvider: 'stripe',
  androidPayMode: 'test', // 'test' || 'production'
  phoneNumberExample: '06 96 00 00 00',
  requireCGUOnSignUp: true,
  skipYourUsagePage: true,
  timeUsageFormat: 'hours', // 'hours' | 'minutes'
  timezoneOffsetInMinutes: 300, // GMT+1 = -60, GMT-1 = +60
  useTemporaryMsisdn: true,
  validationEmailNumberOfDigits: 4,
  idPictureResize: {
    width: 800,
    height: 600,
    compressionRate: 50,
  },
  AGREEMENT_TYPES: {
    PRICING_CONDITIONS: 'CONTRACT_RECAP',
  },
  EXTERNAL_ID_REGEX: /^[a-z]{5}\d{4}$/gim,
  STATIC_FILE_NAME: {
    privacyPolicy: 'privacy_policy.pdf',
    withdrawalAndNotice: 'withdrawal_form_and_notice.pdf',
  },
  UI_URL: 'https://api-kaizen.tparici.com/apiui',
  MAX_SCAN_TIME: 30000,
  MAX_SCAN_TRIES: 3,
  EMAIL_REGEX: /^[\w-\+]+(\.[\w-\+]+)*@[\w-]+(\.[\w]+)*(\.[a-z]{2,})$/,
  LOCAL_PHONE_NUMBER_REGEX: {
    all: /^(0(6|7)90|0(6|7)91|0(6|7)94|0(6|7)96|0(6|7)97)\d{6}$/,
    BLM: /^(0(6|7)90|0(6|7)91)\d{6}$/,
    GLP: /^(0(6|7)90|0(6|7)91)\d{6}$/,
    GUF: /^0(6|7)94\d{6}$/,
    MAF: /^(0(6|7)90|0(6|7)91)\d{6}$/,
    MTQ: /^(0(6|7)96|0(6|7)97)\d{6}$/,
  },
  LOCAL_PHONE_INDICATIVE: {
    BLM: '+590',
    GLP: '+590',
    GUF: '+594',
    MAF: '+590',
    MTQ: '+596',
  },
  PHONE_NUMBER_REGEX: /^\d{10,15}$|^\+?\d{10,15}$/,
  RIO_NUMBER_REGEX: /^[A-Z0-9+]{12}$/,
  VALID_REGION_POST_CODE_REGEX: /^(971|972|973).{2}/,
  ONLY_NUMBER_POST_CODE_REGEX: /^\d{5}$/,
  WEB_HEADER_LOGO_REDIRECTION_URL: 'https://kaizen.tparici.com',
  eSimCarrierApp: {
    VALID: {
      smdpAddress: 'digicelguadeloupe.validspereachdpplus.com',
    },
  },
  GENESYS_SUPPORT_URL: 'https://recette.wizzee.w3b-experience.net/support/',
  GENESYS_DELETE_ACCOUNT_URL:
    'https://recette.wizzee.w3b-experience.net/support/#/articles/comment-supprimer-mon-compte-wizzee----fe059e05-acf5-4145-8d70-5c59e90c5798',
  MGM_DETAIL_LINK_URL:
    'https://recette.wizzee.w3b-experience.net/support/#/articles/comment-parrainer-un-ami----46fa8c63-28ab-4402-9dce-06082d6a20b4',
  MYWALLET_DETAIL_LINK_URL:
    'https://recette.wizzee.w3b-experience.net/support/#/articles/quest-ce-que-le-wallet----ffef168e-79e6-48e8-af81-c6ac65b25002',

  // --- APPLICATION DE ENVCONFIG GLOBAL ---
  ...envConfig,

  // 2. Définition de envSpecific (Fusion config interne + envConfig)
  envSpecific: {
    dev: {
      locales: ['fr'],
      ADAPTOR_URL: 'https://api-kaizen.tparici.com/apiadaptor',
      API_PING_URL: 'https://api-kaizen.tparici.com/ping',
      API_URL: 'https://api-kaizen.tparici.com/api',
      EXTERNAL_WEBVIEW_URL: 'https://wizzeewebapptest.z21.web.core.windows.net',
      BASE_TRANSLATIONS_URL: 'https://fwi-stg-apim.digicelgroup.com/api/tripica/v1/wizzee/cache/datas/{language}/json',
      BASE_UNIVERSAL_LINK_URL: 'https://api-kaizen.tparici.com/assets/index.html#',
      BRAND_HOME_URL: 'https://www.wizzee.fr/',
      EXTERNAL_WEBVIEW_URL: 'https://dev.wizzee.w3b-experience.net/webapp',
      STATIC_CONFIG_URL: 'https://api-kaizen.tparici.com/static/configuration/configuration.json',
      TRPC_FILE_URL: 'https://api-kaizen.tparici.com/api/private/v1/file/{fileOuid}/content',
      STATIC_FILE_URL: 'https://api-kaizen.tparici.com/files/{fileName}',
      ZENDESK_URL: 'https://api-kaizen.tparici.com/api/v1/zendesk/login/noredirect',
      canTerminateLine: true,
      skipYourUsagePage: false,
      DIGICEL_STATIC_DATAS_APIKEY: 'lhhgNx3d5VWGDZ3X6up6OiT3GvKjf4Cy',
      GOOGLE_PLAYSTORE_WIZZEE_LINK: 'https://play.google.com/store/apps/details?id=com.digicelgroup.wizzee',
      APPLE_APPSTORE_WIZZEE_LINK: 'https://apps.apple.com/us/app/wizzee/id1464160388',
      ...(envConfig.envSpecific ? envConfig.envSpecific.dev : {}),
    },
    stage: {
      locales: ['fr'], // locales[0] will be the default value if the customerLanguage isn't supported
      ADAPTOR_URL: 'https://api-kaizen-stage.tparici.com/apiadaptor',
      API_PING_URL: 'https://api-kaizen-stage.tparici.com/ping',
      API_URL: 'https://api-kaizen-stage.tparici.com/api',
      BASE_TRANSLATIONS_URL: 'https://fwi-stg-apim.digicelgroup.com/api/tripica/v1/wizzee/cache/datas/{language}/json',
      BASE_UNIVERSAL_LINK_URL: 'https://api-kaizen-stage.tparici.com/assets/index.html#',
      EXTERNAL_WEBVIEW_URL: 'https://stgfwiwizzeewebapps01.z13.web.core.windows.net',
      STATIC_CONFIG_URL: 'https://api-kaizen-stage.tparici.com/static/configuration/configuration.json',
      TRPC_FILE_URL: 'https://api-kaizen-stage.tparici.com/api/private/v1/file/{fileOuid}/content',
      STATIC_FILE_URL: 'https://api-kaizen-stage.tparici.com/files/{fileName}',
      UI_URL: 'https://api-kaizen-stage.tparici.com/apiui',
      ZENDESK_URL: 'https://api-kaizen-stage.tparici.com/api/v1/zendesk/login/noredirect',
      areCheatCodesEnabled: false,
      showBatchDebugView: true,
      DIGICEL_STATIC_DATAS_APIKEY: 'lhhgNx3d5VWGDZ3X6up6OiT3GvKjf4Cy',
      GOOGLE_PLAYSTORE_WIZZEE_LINK: 'https://play.google.com/store/apps/details?id=com.digicelgroup.wizzee',
      APPLE_APPSTORE_WIZZEE_LINK: 'https://apps.apple.com/us/app/wizzee/id1464160388',
      enableRoamingOptionsMockInCurrentSubscription: true,
      enableRoamingOptionsUsagesMock: true,
      ...(envConfig.envSpecific ? envConfig.envSpecific.stage : {}),
    },
    prod: {
      locales: ['fr'], // locales[0] will be the default value if the customerLanguage isn't supported
      androidPayMode: 'production',
      ADAPTOR_URL: 'https://app.wizzee.fr/apiadaptor',
      API_PING_URL: 'https://app.wizzee.fr/ping',
      API_URL: 'https://app.wizzee.fr/api',
      BASE_TRANSLATIONS_URL: 'https://fwi-apim.digicelgroup.com/api/tripica/v1/wizzee/cache/datas/{language}/json',
      BASE_UNIVERSAL_LINK_URL: 'https://app.wizzee.fr/assets/index.html#',
      EXTERNAL_WEBVIEW_URL: 'https://fwiwizzeewebapps01.z13.web.core.windows.net',
      STATIC_CONFIG_URL: 'https://app.wizzee.fr/static/configuration/configuration.json',
      TRPC_FILE_URL: 'https://app.wizzee.fr/api/private/v1/file/{fileOuid}/content',
      STATIC_FILE_URL: 'https://app.wizzee.fr/files/{fileName}',
      UI_URL: 'https://app.wizzee.fr/apiui',
      ZENDESK_URL: 'https://app.wizzee.fr/api/v1/zendesk/login/noredirect',
      GENESYS_SUPPORT_URL: 'https://www.wizzee.fr/support/',
      DIGICEL_STATIC_DATAS_APIKEY: 'nAKek71WcFmQ1BGYa1iuRSny0R7F4OPW',
      areCheatCodesEnabled: false,
      showBatchDebugView: false,
      GOOGLE_PLAYSTORE_WIZZEE_LINK: 'https://play.google.com/store/apps/details?id=com.digicelgroup.wizzee',
      APPLE_APPSTORE_WIZZEE_LINK: 'https://apps.apple.com/us/app/wizzee/id1464160388',
      ...(envConfig.envSpecific ? envConfig.envSpecific.prod : {}),
    },
  },
};

// 3. Application du fallback (Mobile ou Web Local via env.js)
const currentEnv = require('../env');
if (config.envSpecific[currentEnv]) {
  config = { ...config, ...config.envSpecific[currentEnv] };
}

// 4. SURCHARGE DYNAMIQUE (Web Azure uniquement)
if (dynamic.ENV) {
  // On récupère les surcharges éventuelles de envConfig pour l'environnement Azure
  const extraEnvConfig =
    envConfig.envSpecific && envConfig.envSpecific[dynamic.ENV]
      ? envConfig.envSpecific[dynamic.ENV]
      : {};

  config = {
    ...config,
    ...extraEnvConfig,
    locales: dynamic.LOCALES ? JSON.parse(dynamic.LOCALES) : config.locales,
    androidPayMode: dynamic.ENV === 'prod' ? 'production' : 'test',
    ADAPTOR_URL: dynamic.ADAPTOR_URL || config.ADAPTOR_URL,
    API_PING_URL: dynamic.API_PING_URL || config.API_PING_URL,
    API_URL: dynamic.API_URL || config.API_URL,
    BASE_TRANSLATIONS_URL: dynamic.BASE_TRANSLATIONS_URL || config.BASE_TRANSLATIONS_URL,
    BASE_UNIVERSAL_LINK_URL: dynamic.BASE_UNIVERSAL_LINK_URL || config.BASE_UNIVERSAL_LINK_URL,
    EXTERNAL_WEBVIEW_URL: dynamic.EXTERNAL_WEBVIEW_URL || config.EXTERNAL_WEBVIEW_URL,
    STATIC_CONFIG_URL: dynamic.STATIC_CONFIG_URL || config.STATIC_CONFIG_URL,
    TRPC_FILE_URL: dynamic.TRPC_FILE_URL || config.TRPC_FILE_URL,
    STATIC_FILE_URL: dynamic.STATIC_FILE_URL || config.STATIC_FILE_URL,
    UI_URL: dynamic.UI_URL || config.UI_URL,
    ZENDESK_URL: dynamic.ZENDESK_URL || config.ZENDESK_URL,
    GENESYS_SUPPORT_URL: dynamic.GENESYS_SUPPORT_URL || config.GENESYS_SUPPORT_URL,
    DIGICEL_STATIC_DATAS_APIKEY: dynamic.DIGICEL_STATIC_DATAS_APIKEY || config.DIGICEL_STATIC_DATAS_APIKEY,
    GOOGLE_PLAYSTORE_WIZZEE_LINK: dynamic.GOOGLE_PLAYSTORE_WIZZEE_LINK || config.GOOGLE_PLAYSTORE_WIZZEE_LINK,
    APPLE_APPSTORE_WIZZEE_LINK: dynamic.APPLE_APPSTORE_WIZZEE_LINK || config.APPLE_APPSTORE_WIZZEE_LINK,
    areCheatCodesEnabled:
      dynamic.ENV === 'prod'
        ? false
        : dynamic.ARE_CHEAT_CODES_ENABLED === 'true' || config.areCheatCodesEnabled,
    showBatchDebugView:
      dynamic.ENV === 'prod'
        ? false
        : dynamic.SHOW_BATCH_DEBUG_VIEW === 'true' || config.showBatchDebugView,
  };
}

// Nettoyage final de la config avant export (on retire envSpecific qui n'a plus d'utilité à ce stade)
delete config.envSpecific;

module.exports = config;